import { Dialog } from "@headlessui/react";
import { ModalHeaderBox, ModalFoterBox, FormBox } from "../../components/box/Box";
import Button from "../../components/button/Button";
import { Modal, ModalProp } from "../../components/modal/Modal";
import FormController from "../../components/fields/FormController";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect } from "react";

export type EditPasswordModalProp = {
  onSubmit: (data: PasscodeEdit) => Promise<void>;
}

export type PasscodeEdit = {
  passcode: string,
  confirmationPasscode: string,
}

const passcodeSchema = yup.object({
  passcode: yup.string().matches(/^[0-9]+$/, '数字のみで入力してください。').min(11).max(11).required(),
  confirmationPasscode: yup.string().oneOf([yup.ref('passcode')], 'パスワードが一致しません。').required(),
});

export const EditPasswordModal = ({
  open,
  toggle,
  closeOnClickOutside,
  onSubmit,
}: ModalProp & EditPasswordModalProp) => {
  const { control, handleSubmit, reset } =
    useForm<PasscodeEdit>({
      resolver: yupResolver(passcodeSchema),
    });

  // キャンセルの処理
  useEffect(() => {
      reset();
  },[open, reset]);

  return (
    <Modal
      open={open}
      toggle={toggle}
      closeOnClickOutside={closeOnClickOutside}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all max-w-screen-sm">
          <div className="p-4">
            <ModalHeaderBox title={"パスワード変更"}/>
            <FormBox>
              <FormController
                control={control}
                name={"passcode"}
                label={"パスワード"}
                type={"password"}
                required
              />
              <FormController
                control={control}
                name={"confirmationPasscode"}
                label={"パスワード確認用"}
                type={"password"}
                required
              />
            </FormBox>
          </div>
          <ModalFoterBox>
            <Button
              outline
              onClick={toggle}
              children={"キャンセル"}
              className={"mr-2 w-[132px]"}
            />
            <Button
              submit
              children={"登録"}
              className={"w-[132px]"}
            />
          </ModalFoterBox>
        </Dialog.Panel>
      </form>
    </Modal>
  );
}